import { useQuery } from '@tanstack/react-query'
import { listTopazVersions } from '../lib/endpoints/jobs'
import { qk } from '../lib/queryKeys'

/** Versions advertised by approved hosts, including currently-offline hosts. */
export function useTopazVersions() {
  return useQuery({
    queryKey: qk.topazVersions(),
    queryFn: listTopazVersions,
    staleTime: 60_000,
  })
}
